var _path, _path2, _path3, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M4.072 20.125C4.072 27.788 10.284 34 17.948 34c7.662 0 13.874-6.212 13.874-13.875l-6.71-3.31-6.076 4.014-2.714-2.094-3.447 1.062-2.352-1.626z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M14.41 25.211a.97.97 0 0 1-.97-.97v-.486a.97.97 0 1 1 1.94 0v.486a.97.97 0 0 1-.97.97M21.484 25.211a.97.97 0 0 1-.97-.97v-.486a.97.97 0 1 1 1.94 0v.486a.97.97 0 0 1-.97.97",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M21.47 29.39a3.1 3.1 0 0 0-.35-1.194 3.4 3.4 0 0 0-1.285-1.323 3.74 3.74 0 0 0-1.888-.505c-.66 0-1.317.17-1.889.505a3.4 3.4 0 0 0-1.282 1.323c-.195.367-.317.78-.35 1.195-.023.29-.005.592.076.872.09.306.292.565.574.715.203.109.428.15.656.123.864-.105.974-.6 2.215-.6 1.242 0 1.352.494 2.215.6.229.027.453-.014.657-.123.28-.15.484-.41.573-.715.081-.28.1-.582.077-.872",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "error_svg__a",
    width: 30,
    height: 19,
    x: 3,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 2h29.895v18.829H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m16.322 18.735 2.714 2.093 3.886-2.566-.178-1.774a7.1 7.1 0 0 0 2.608-1.074c.79.62 1.76 1 2.822 1 2.607 0 4.72-2.213 4.72-4.943s-2.113-4.943-4.72-4.943c-.04 0-.076.011-.116.012C26.98 3.877 24.4 2 21.388 2c-2.684 0-5.02 1.49-6.261 3.695a5.8 5.8 0 0 0-2.412-.529 5.81 5.81 0 0 0-5.003 2.865c-.079-.003-.154-.022-.232-.022C5.005 8.01 3 9.938 3 12.316s2.005 4.306 4.48 4.306c.837 0 1.611-.235 2.282-.62a5.8 5.8 0 0 0 2.953.813c.137 0 .27-.012.405-.02l-.297 2.965.052.037z",
    clipRule: "evenodd"
  }))));
};
export default SvgError;